import { Loader2 } from 'lucide-react';

export function LoadingScreen() {
  return (
    <div className="flex items-center justify-center h-screen bg-surface-subtle">
      <div className="flex flex-col items-center gap-4">
        <Loader2 size={32} className="animate-spin text-brand-primary" />
        <p className="text-md font-medium text-text-secondary">Loading QHRMS...</p>
      </div>
    </div>
  );
}

export function LoadingSpinner({ size = 24, className = '' }: { size?: number; className?: string }) {
  return (
    <div className={`flex items-center justify-center py-12 ${className}`}>
      <Loader2 size={size} className="animate-spin text-text-muted" />
    </div>
  );
}
